const config = {
  baseDisasterUrl: 'https://disaster-api.openrouteservice.org/',
  regionIdField: 'instance',
}
export default config
